export default __webpack_public_path__ + "static/media/pow2.56016ef0.png";